export enum RegionId {
    northAmerica = 1,
    latinAmerica = 2,
    europe = 4,
    asia = 8,
}
